<div nimbusDropFile class="chat-widget-root" [isDropFileDisabled]="!isDragAndDropSupported" (filesDropped)="onFilesDropped($event)">
  <nimbus-chat-messages
    class="full"
    [messages]="messages"
    [chatType]="chatType"
    [taskState]="taskState"
    [emptyTemplate]="emptyTemplate"
    [authorInfoTemplate]="authorInfoTemplate"
    [showActions]="showActions"
    [hideAuthorTime]="hideAuthorTime"
    [hasMoreMessages]="hasMoreMessages"
    [formResolver]="formResolver"
    (copyTextInitialized)="onCopyTextInitialized($event)"
    (messageSent)="onMessageSent($event)"
    (loadPrevMessagesRequested)="onLoadPrevMessagesRequested()"
    (formResolved)="formResolved.emit($event)"
    (formActionInvoked)="formActionInvoked.emit($event)"
  ></nimbus-chat-messages>

  @if (!hideInput) {
    @if (showParkedBanner) {
      <div class="parked-banner">
        <span class="parked-banner-info">
          <i [nimbusIcon]="ICONS.PARK_ROUND" [iconWeight]="IconWeight.Regular"></i>
          <span>{{ TranslationKeys.MySessionsChatParkedBannerText | translate }}</span>
        </span>
        <button nimbusPrimaryButton class="parked-banner-unpark" [disabled]="unparkDisabled" (click)="onUnpark()">
          <i [nimbusIcon]="ICONS.UNPARK_ROUND" [iconWeight]="IconWeight.Regular"></i>
          <span>{{ TranslationKeys.ConversationUnpark | translate }}</span>
          <nimbus-tooltip [text]="unparkTooltip | translate"></nimbus-tooltip>
        </button>
      </div>
    }

    <div class="chat-widget-composer">
      @if (hasPendingForm) {
        <nimbus-info-banner variant="warning">{{ TranslationKeys.ChatWidgetFormPendingHint | translate }}</nimbus-info-banner>
      }

      <nimbus-chat-input-message
        [taskState]="taskState"
        [chatType]="chatType"
        [inputDisabled]="inputDisabled || hasPendingForm"
        [saveDraftApiUrl]="saveDraftApiUrl"
        [conversationId]="conversationId"
        [enableDraft]="enableDraft"
        [isMediaHandlingEnabled]="isMediaHandlingEnabled"
        [mediaPolicy]="mediaPolicy"
        [isCustomerChat]="isCustomerChat"
        (messageSent)="onMessageSent($event)"
        (attachmentsSent)="onAttachmentsSent($event)"
        (voiceMessageSent)="onVoiceMessageSent($event)"
      ></nimbus-chat-input-message>
    </div>
  }

  <div class="chat-widget-drop-overlay"></div>
</div>
